import { IUser } from '../../types/interfaces/user';

export function getUserViewName(user: IUser) {
  return [user?.firstname, user?.lastname].filter(Boolean).join(' ');
}
